<template>
<div class="">
    <PageBreadcrumb :pagetitle="info.title"/>
    <!-- Article -->
    <section class="articlesec py-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-12">
                    <div class="heading mb-4">
                        <h2>Latest Articles</h2>
                        <hr class="brd-primary ml-0">
                    </div>
                </div>
                <div class="col-12 col-lg-9 mb-5 mb-lg-0">
                    <article class="article-block" v-for="article in articles" :key="article.nid">
                        <div class="articleimg shrink-effect">
                            <img v-bind:src="article.field_basic_image" class="img-fluid rounded" alt="" />
                        </div>
                        <div class="article-content">
                            <a href="#"><h5 class="mb-1">{{ article.title }}</h5></a>
                            <div class="article-author text-dark py-2 font-weight-bold">
                                <span><i class="fa fa-user-o"></i> by {{ article.uid }}</span>
                                <span><i class="fa fa-calendar"></i> {{ article.created }}</span>
                            </div>
                            <p class="mb-1">{{ article.body }}</p>
                            <a href="#">Continue Reading <i class="fa fa-long-arrow-right pl-1"></i></a>
                        </div>
                    </article>
                    <nav>
                        <ul class="pagination mb-0 justify-content-center">
                            <li class="page-item"><a class="page-link" href="#">Previous</a></li>
                            <li class="page-item active"><a class="page-link" href="#">1</a></li>
                            <li class="page-item"><a class="page-link" href="#">2</a></li>
                            <li class="page-item"><a class="page-link" href="#">3</a></li>
                            <li class="page-item"><a class="page-link" href="#">Next</a></li>
                        </ul>
                    </nav>
                </div>
                <div class="col-12 col-lg-3">
                    <!-- Start SideBarExtras -->
                    <SideBarExtras />
                    <!-- Start SideBarExtras -->
                    <div class="eventdiv">
                        <router-link to="#"><img src="../assets/images/event.jpg" alt="" class="img-fluid" /></router-link>
                    </div>
                    <hr>
                    <div class="eventdiv">
                        <a href="#"><img src="../assets/images/event.jpg" alt="" class="img-fluid" /></a>
                    </div>
                    <hr>
                    <div class="right-title">
                        <h5>Account Login</h5>
                        <form class="login-form">
                            <div class="form-group position-relative">
                                <input type="email" name="email" placeholder="Email" class="form-control pr-4" />
                                <span class="formicon"><i class="fa fa-user"></i></span>
                            </div>
                            <div class="form-group position-relative">
                                <input type="password" name="password" placeholder="Password" class="form-control pr-4" />
                                <span class="formicon"><i class="fa fa-lock"></i></span>
                            </div>
                            <div class="form-group-btn">
                                <input type="submit" value="Login" class="btn btn-primary text-uppercase btn-block rounded-0 mb-1" />
                            </div>
                        </form>
                        <div class="text-dark text-center">
                            Create an account <a href="#"><u>Register</u></a>
                        </div>
                    </div>
                    <hr>
                    <div class="right-title">
                        <h5>Recent Comments</h5>
                        <ul class="list-unstyled mb-0 comment-list">
                            <li>
                                <a href="#" class="text-light">
                                    <div class="commentimg shrink-effect float-left mr-3">
                                        <img src="images/comment.jpg" alt="" class="img-fluid" />
                                    </div>
                                    <div class="comment-txt">
                                        <h6 class="mb-1">Glory be to the Almighty God</h6>
                                        <span><i class="fa fa-calendar"></i> 2 years 45 weeks ago</span>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="text-light">
                                    <div class="commentimg shrink-effect float-left mr-3">
                                        <img src="../assets/images/comment.jpg" alt="" class="img-fluid" />
                                    </div>
                                    <div class="comment-txt">
                                        <h6 class="mb-1">Glory be to the Almighty God</h6>
                                        <span><i class="fa fa-calendar"></i> 2 years 45 weeks ago</span>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="text-light">
                                    <div class="commentimg shrink-effect float-left mr-3">
                                        <img src="../assets/images/comment.jpg" alt="" class="img-fluid" />
                                    </div>
                                    <div class="comment-txt">
                                        <h6 class="mb-1">Glory be to the Almighty God</h6>
                                        <span><i class="fa fa-calendar"></i> 2 years 45 weeks ago</span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Article -->
</div>
</template>

<script>
import axios from 'axios';
import PageBreadcrumb from '@/components/PageBreadcrumb'
// @ is an alias to /src
import GreenAudioPlayer from '../assets/js/green-audio-player.js'
import Swiper from '../assets/js/swiper.min.js'

export default {
    name: 'Article',
    data(){
        return {
            info: { title : "Articles" },
            articles: [],
            swiper: "",
            serviceSlider: "",
            testimonialSlider: "",
            marquee: "",
        }
    },
    components:{
        PageBreadcrumb
    },
    mounted() {
        document.addEventListener('DOMContentLoaded', function() {
            new GreenAudioPlayer('.ready-player-1');
            });

            //Home Slider
            this.swiper = new Swiper('#home-slider', {
                effect: 'fade',
                navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        //Service Slider
        this.serviceSlider = new Swiper('#service-slider', {
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                681: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            }
        });

        //Testimonial Slider
        this.testimonialSlider = new Swiper('#testimonial-slider', {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        //Top Slider
        this.marquee = new Swiper('#marquee', {
            effect: 'fade',
            autoplay: {
                delay: 1500,
                disableOnInteraction: false,
            },
        });

        axios
        .get('https://api.fifmi.org.au/api/articles')
        .then(result => {
            for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].type == "article"){
                    this.articles.push(result.data[i])
                }
            }
        });
    },
}
</script>
